import React from "react";
import PropTypes from "prop-types";
import StructuralVariant from "../../../../../../models/StructuralVariant";
import store from "../../../../../../state/store";
import Limiter from "../../../../../../components/atoms/Limiter";
import Btn from "../../../../../../components/atoms/Btn";
import getPrettyNumberFormat from "../../../../helpers/getPrettyNumberFormat";

function Decipher({ item }) {
  const { varsomeHost } = store.getState();
  const mRatio = item?.regionData?.mean_ratio;
  const options = { maxFract: 3, defaultVal: "-" };
  const meanRatio = getPrettyNumberFormat(mRatio, options);

  return (
    <div className="tw-px-1 tw-py-px">
      <div>
        {item?.regionData?.inheritance ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-24">Inheritance</div>
            <div className="tw-flex-grow">{item.regionData.inheritance}</div>
          </div>
        ) : null}

        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Mean ratio</div>
          <div className="tw-flex-grow">{meanRatio ?? "-"}</div>
        </div>

        {item?.regionData?.phenotypes?.length > 0 ? (
          <div className="tooltip-row tw-max-w-96 tw-flex-wrap">
            <div className="tooltip-label tw-w-24">Phenotypes</div>
            <div>
              <Limiter
                items={item.regionData.phenotypes}
                limit={3}
                ExpandLink={({ remaining, toggle, isExpanded }) => (
                  <div className="tw-mb-0.5 tw-inline-block">
                    <Btn
                      className="tw-ml-1 tw-text-primary link tw-text-2xs"
                      onSubmit={toggle}
                    >
                      {isExpanded ? `show fewer` : `+ ${remaining} more`}
                    </Btn>
                  </div>
                )}
                renderContent={({ items }) => (
                  <>
                    {items.map((x) => (
                      <a
                        key={x.name}
                        target="_blank"
                        href={`${varsomeHost}/search-results/${x.name}`}
                        className="tw-px-1 tw-py-0.5 tw-text-2xs tw-inline-block tw-bg-sky-500 tw-bg-opacity-20 tw-mr-1 tw-mb-0.5 tw-font-semibold tw-text-sky-500 tw-rounded-md"
                      >
                        {x.name}
                      </a>
                    ))}
                  </>
                )}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

Decipher.propTypes = {
  item: PropTypes.instanceOf(StructuralVariant).isRequired,
};

Decipher.defaultProps = {};

export default Decipher;
